import React, { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { OptionCard, RegContainer } from '@/components';
import { BREAKPOINTS, Container, Flex } from '@/ui';
import CreateAccountIcon from '@/assets/entry-pages/create-account.svg';
import LoginAccountIcon from '@/assets/entry-pages/login-account.svg';
import { useTranslation } from 'react-i18next';
import { useGetStatics } from '@/hooks/useGetStatics';
import { API_URL } from '@/utils/static';
import styled from 'styled-components';

export const EnterPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data, isLoading } = useGetStatics();

  const logoStatics = useMemo(() => data && data.find((item) => item.title === 'logo'), [data]);

  return (
    <RegContainer type='centered' style={{ maxWidth: 'unset' }}>
      <StyledImgContainer $marginTop={20}>
        <Img src={isLoading || !logoStatics ? '' : `${API_URL}/${logoStatics.text}`} alt='logo' />
      </StyledImgContainer>

      <StyledOptionRow $wide justify={'center'} gap={64}>
        <OptionCard
          title={t('Create a new \nverification account...')}
          onClick={() => navigate('/registration/investor')}
          icon={CreateAccountIcon}
        />

        <OptionCard
          title={t('Login in existing \nverification account.')}
          onClick={() => navigate('/login')}
          icon={LoginAccountIcon}
        />
      </StyledOptionRow>
    </RegContainer>
  );
};

const Img = styled.img`
  width: 200px;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    width: 160px;
  }
`;

const StyledOptionRow = styled(Flex)`
  @media (max-width: ${BREAKPOINTS.sm}px) {
    margin-bottom: 40px;
    gap: 36px;
    flex-direction: column;
    align-items: center;
  }
`;

const StyledImgContainer = styled(Container)`
  margin-bottom: 48px;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    margin-bottom: 40px;
  }
`;
